import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdNotifications, MdPerson, MdLogout } from 'react-icons/md';
import './Header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h5 className="page-title">Accounting & Payroll System</h5>
        </div>
        <div className="header-right">
          <button className="icon-btn">
            <MdNotifications />
            <span className="badge">3</span>
          </button>
          <div className="user-menu">
            <div className="user-info">
              <MdPerson className="user-icon" />
              <span className="user-name">{user.name || 'Admin'}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <MdLogout />
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
